import React from 'react';

// todo: convert to HOC
class ModalEnabledComponent extends React.Component {
  state = {
    openModal: ''
  };

  render() {
    return '';
  }

  isOpen = id => {
    const { openModal } = this.state;
    return openModal === id;
  };

  closeModal = (more = {}) => {
    this.setState({ openModal: '', ...more });
  };

  /**
   * Opens a modal, You can also pass a secondary object to update state.
   * @param id
   * @param more
   */
  openModal = (id, more = {}) => {
    this.setState({ openModal: id, ...more });
  };
}

export default ModalEnabledComponent;



// WEBPACK FOOTER //
// ./src/components/extend/ModalEnabled.js